/**
 * Variables dans le texte d'un modèle : `{{variable}}` (nôtre) et `{VARIABLE}` (héritage
 * Urable, encore dans les modèles de production). Mêmes motifs que le rendu côté API.
 */
export const VARIABLE_TOKEN = /(\{\{\s*[a-zA-Z0-9_]+\s*\}\}|\{[A-Z][A-Z0-9_]+\})/g;

export interface Segment {
  text: string;
  variable: boolean;
}

/** Découpe un texte en segments, les variables à part, pour les surligner. */
export function splitVariables(text: string): Segment[] {
  const out: Segment[] = [];
  let last = 0;
  for (const m of text.matchAll(VARIABLE_TOKEN)) {
    const at = m.index ?? 0;
    if (at > last) out.push({ text: text.slice(last, at), variable: false });
    out.push({ text: m[0], variable: true });
    last = at + m[0].length;
  }
  if (last < text.length) out.push({ text: text.slice(last), variable: false });
  return out;
}

/**
 * Insère `token` à la sélection (`start`..`end`, bornées au texte ; à la fin par défaut)
 * et renvoie le texte obtenu avec la position du curseur juste après le jeton.
 */
export function insertAt(
  value: string,
  token: string,
  start: number = value.length,
  end: number = start,
): { value: string; caret: number } {
  const from = Math.max(0, Math.min(start, value.length));
  const to = Math.max(from, Math.min(end, value.length));
  return { value: value.slice(0, from) + token + value.slice(to), caret: from + token.length };
}
